import moment from 'moment/moment';

import 'moment/locale/th';

export default function DateConvertByMoment(date, formatDate) {

    let fmd
    if (formatDate !== "" && typeof formatDate !== "undefined") {
        fmd = formatDate
    } else {
        fmd = "YYYY-MM-DD"
    }

    return moment(date, fmd, 'Th')
}